export default [
  {
    path: '/v2/student-scoring-entries/single-score-copy',
    name: 'student-scoring-entries-single-score-copy',
    meta: { requiresAuth: true },
    component: () => import('./views/single-copy.vue')
  }
]
